<template>
  <section>
    <br>
    <div class="al-tabs-container">
      <!-- <div
        v-if="tabs.length > 1"
        class="al-tabs-title overflow-x-scroll overflow-y-hidden"
      >
        <template v-for="tab in tabs">
          <button
            :key="tab.id"
            class="button"
            :class="selectedTab === tab.id ? 'selected' : ''"
            @click="handleSelectTab(tab.id)"
          >
            {{ tab.title }}
          </button>
        </template>
      </div> -->
      <!-- <div class="al-tabs">
        <div
          v-if="selectedTab === allTabs.ACTIVE_CLIENTS"
          class="al-tab"
        >
          <active-clients />
        </div>
        <div
          v-if="selectedTab === allTabs.LIEN_AUCTION_ANALYZE"
          class="al-tab"
        >
          <lien-auction-analyze />
        </div>
        <div
          v-if="selectedTab === allTabs.TENANTS_AUCTION_STEP"
          class="al-tab"
        >
          <tenants-auction-step />
        </div>
        <div
          v-if="selectedTab === allTabs.TENANTS_INFO"
          class="al-tab"
        >
          <tenants-info />
        </div>
        <div
          v-if="selectedTab === allTabs.STATE_LAWS"
          class="al-tab"
        >
          <state-laws />
        </div>
        <div
          v-if="selectedTab === allTabs.PROOF_MAILING"
          class="al-tab"
        >
          <proof-mailing />
        </div>
        <div
          v-if="selectedTab === allTabs.DELETED_LIENS"
          class="al-tab"
        >
          <deleted-liens />
        </div>
        <div
          v-if="selectedTab === allTabs.DOWNLOAD_REPORT"
          class="al-tab"
        >
          <download-report />
        </div>
        <div
          v-if="selectedTab === allTabs.SYSTEM_REPORTS"
          class="al-tab"
        >
          <SystemReports />
        </div>
      </div> -->
      <SystemReports />
    </div>
    <br>
  </section>
</template>
<script>
// import {Roles} from '@/constants';
// import LienAuctionAnalyze from '@/components/reports/LienAuctionAnalyze';
// import TenantsAuctionStep from '@/components/reports/TenantsAuctionStep';
// import ActiveClients from '@/components/reports/ActiveClients';
// import StateLaws from '@/components/reports/StateLaws';
// import TenantsInfo from '@/components/reports/TenantsInfo';
// import ProofMailing from '@/components/reports/ProofMailing';
// import DeletedLiens from '@/components/reports/DeletedLiens';
// import DownloadReport from '@/components/reports/DownloadReport';
import SystemReports from '@/components/reports/SystemReports';

const TABS = {
  LIEN_AUCTION_ANALYZE: 'LIEN_AUCTION_ANALYZE',
  TENANTS_AUCTION_STEP: 'TENANTS_AUCTION_STEP',
  ACTIVE_CLIENTS: 'ACTIVE_CLIENTS',
  STATE_LAWS: 'STATE_LAWS',
  TENANTS_INFO: 'TENANTS_INFO',
  PROOF_MAILING: 'PROOF_MAILING',
  DELETED_LIENS: 'DELETED_LIENS',
  DOWNLOAD_REPORT: 'DOWNLOAD_REPORT',
  SYSTEM_REPORTS: 'SYSTEM_REPORTS'
};
export default {
  name: 'ReportsComponent',
  components: {
    // LienAuctionAnalyze,
    // TenantsAuctionStep,
    // ActiveClients,
    // StateLaws,
    // TenantsInfo,
    // ProofMailing,
    // DeletedLiens,
    // DownloadReport,
    SystemReports
  },

  data() {
    return {
      role: this.$store.state.user.role,
      tabs: [],
      selectedTab: null,
      allTabs: TABS
    };
  },
  mounted() {
    this.generateTabs();
  },
  methods: {
    handleSelectTab(key) {
      this.selectedTab = key;
      this.$store.commit('setSelectedTab', { reports: key });
    },
    generateTabs() {
      this.tabs = [
        {
          id: TABS.ACTIVE_CLIENTS,
          title: 'Active clients',
          visible: true
        },
        // {
        //   id: TABS.LIEN_AUCTION_ANALYZE,
        //   title: "Lien to auction analyze",
        //   visible: true,
        // },
        {
          id: TABS.STATE_LAWS,
          title: 'State laws',
          visible: true
        },
        {
          id: TABS.PROOF_MAILING,
          title: 'Proof of mailing',
          visible: true
        },
        {
          id: TABS.TENANTS_AUCTION_STEP,
          title: 'Auctions step',
          visible: true
        },
        {
          id: TABS.DELETED_LIENS,
          title: 'Deleted liens',
          visible: true
        },
        {
          id: TABS.TENANTS_INFO,
          title: 'Tenants info',
          visible: true
        },
        {
          id: TABS.DOWNLOAD_REPORT,
          title: 'Download report',
          visible: true
        },
        {
          id: TABS.SYSTEM_REPORTS,
          title: 'System Reports',
          visible: true
        }
      ];
      this.selectedTab = this.$store.state.tabs.reports || this.tabs[0].id;
    }
  }
};
</script>
<style scoped lang="scss">
.global-info p {
  border-left-width: 4px;
  border-left-style: solid;
  padding-left: 1rem;
}
.al-tab {
  margin-top: 30px !important;
}
</style>
